/**
 * Oprávnění modulu Yield & Ticketing (zrcadlí backend `ColumbusPermissions.Agenda`).
 * Jeden uzel katalogu s úrovněmi: `read` = zobrazení agendy (menu, gate), `edit` = úpravy.
 */
export const COLUMBUS_PERMISSION = 'products.columbus-planner';
